module.exports = __webpack_public_path__ + "img/jinbi_1.727d28f5.png";